export const DUKE_DOMAIN = 'duke.co';
export const DUKE_SUPPORT_EMAIL = `support@${DUKE_DOMAIN}`;

export function emailHasAllowedDomain(allowedDomains: string[], email: string): boolean {
  if (email == null || !Array.isArray(allowedDomains) || allowedDomains.length === 0) {
    return false;
  }

  const emailDomain = email.split('@')[1];
  if (emailDomain == null || emailDomain.length === 0) {
    return false;
  }

  return allowedDomains.some((domain) => emailDomain === domain);
}
